import { env } from "cloudflare:workers";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const postPathSchema = z.object({
	postPath: z.string().min(1).max(512),
});

export const getBlogViewCount = createServerFn({ method: "GET" })
	.inputValidator(postPathSchema)
	.handler(async ({ data }) => {
		const db = env.DB;
		if (!db) {
			return { postPath: data.postPath, viewCount: 0 };
		}
		try {
			const row = await db
				.prepare(
					"SELECT view_count AS c FROM blog_post_views WHERE post_path = ?",
				)
				.bind(data.postPath)
				.first<{ c: number }>();
			return { postPath: data.postPath, viewCount: row?.c ?? 0 };
		} catch {
			return { postPath: data.postPath, viewCount: 0 };
		}
	});

export const recordBlogView = createServerFn({ method: "POST" })
	.inputValidator(postPathSchema)
	.handler(async ({ data }) => {
		const db = env.DB;
		if (!db) {
			return { postPath: data.postPath, viewCount: 0 };
		}
		try {
			await db
				.prepare(
					`INSERT INTO blog_post_views (post_path, view_count, updated_at)
           VALUES (?, 1, datetime('now'))
           ON CONFLICT(post_path) DO UPDATE SET
             view_count = view_count + 1,
             updated_at = datetime('now')`,
				)
				.bind(data.postPath)
				.run();

			const row = await db
				.prepare(
					"SELECT view_count AS c FROM blog_post_views WHERE post_path = ?",
				)
				.bind(data.postPath)
				.first<{ c: number }>();

			return { postPath: data.postPath, viewCount: row?.c ?? 0 };
		} catch {
			return { postPath: data.postPath, viewCount: 0 };
		}
	});
